import { createFileRoute, Link } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/debug/')({
  component: DebugIndex,
});

function DebugIndex() {
  return (
    <div className="p-4">
      <h1 className="mb-2 text-lg font-semibold">Debug</h1>
      <ul className="list-inside list-disc space-y-1">
        <li>
          <Link to="/debug/viewer" className="text-info hover:underline">
            Viewer
          </Link>
        </li>
        <li>
          <Link to="/debug/cache" className="text-info hover:underline">
            Cache
          </Link>
        </li>
        <li>
          <Link to="/debug/thumbnail" className="text-info hover:underline">
            Thumbnail render
          </Link>
        </li>
      </ul>
    </div>
  );
}
